<script setup lang="ts">
import { defineComponent, h, ref } from 'vue'
import { colors, PopupBasicHeader } from 'wepin-vue-component'
import ShowSettings from './ShowSettings.vue'
import { PopupList } from '@/components'
import type { TypePopupItem } from '@/components/popup/list/PopupList.vue'
import { useI18nTypes, useBreakPointsClass } from '@/composables'
import { defaultBreakPoints } from '@/const'
const { breakPointsClass } = useBreakPointsClass(defaultBreakPoints)

const emits = defineEmits<{
  (event: 'select-route', name: string): void
  (event: 'close'): void
}>()
const props = defineProps<{
  changeLayout: string
  editList: string
}>()
const { t } = useI18nTypes()
const listItems = ref<TypePopupItem[]>([
  {
    type: 'item',
    name: t('show_settings.layout'),
    element: {
      name: 'GridView',
      size: 'medium',
      color: colors.currentThemeRef.value.grey_111,
    },
    button: {
      type: 'element',
      name: 'Right',
      size: 'medium',
      color: colors.currentThemeRef.value.grey_111,
    },
    onClick() {
      emits('select-route', props.changeLayout)
    },
  },
  // 정렬 기능 주석처리 ※ 논의 필요
  // {
  //   type: 'item',
  //   name: t('show_settings.sort'),
  //   element: {
  //     name: 'Sort',
  //     size: 'medium',
  //     color: '#000000',
  //   },
  //   button: {
  //     type: 'element',
  //     name: 'Right',
  //     size: 'medium',
  //     color: colors.currentThemeRef.value.grey_111,
  //   },
  //   onClick() {
  //     emits('select-route', 'SortAccounts')
  //   },
  // },
  {
    type: 'item',
    name: t('show_settings.edit_list'),
    element: {
      name: 'FormatLineSpacing',
      size: 'medium',
      color: '#000000',
    },
    button: {
      type: 'element',
      name: 'Right',
      size: 'medium',
      color: colors.currentThemeRef.value.grey_111,
    },
    onClick() {
      emits('select-route', props.editList)
    },
  },
  // {
  //   type: 'line',
  // },
  // {
  //   type: 'item',
  //   name: t('show_settings.hide_little'),
  //   button: {
  //     type: 'toggle',
  //     checked: false,
  //     color: colors.currentThemeRef.value.main,
  //     disabled: false,
  //   },
  // },
])
const onExit = () => {
  emits('close')
}
</script>
<script lang="ts">
export const createShowSettings = (
  onSelectRoute: (name: string) => void,
  changeLayout: string,
  editList: string,
) => {
  return defineComponent<typeof ShowSettings>(() => {
    return () =>
      h(ShowSettings, {
        'onSelect-route': onSelectRoute,
        changeLayout,
        editList,
      })
  })
}
</script>

<template>
  <div class="show-settings" :class="[breakPointsClass]">
    <PopupBasicHeader :title="t('show_settings.title')" :exit="onExit" />
    <div class="popup-body">
      <PopupList :items="listItems" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.show-settings {
  min-width: 360px;
  background-color: var(--grey_fff);
  border-radius: 8px;
  box-shadow: 0px 20px 10px rgba(0, 0, 0, 0.2);
  .popup-body {
    padding: 0 30px 10px 30px;
  }
}

.show-settings.mobile {
  .popup-body {
    padding: 0 20px;
  }
}
</style>
